

async function getSectionHTML(sectionId, productId, isUpsale) {
  return new Promise(function (resolve, reject) {
    const query = "id:" + productId;
    const qq = productId ? "&q=" + query : "";
    const url = window.Shopify.routes.root + "search/?sections=" + sectionId + qq;

    fetch(url).then(function (r) {
      r.json().then(function (res) {
        var keys = Object.keys(res);

        if (keys.length > 0) {
          return resolve(res[keys[0]]);
        }

        return reject();
      });
    });
  });
}

async function setModalContent(section, productId, isUpsale) {
  const html = await getSectionHTML(section, productId, isUpsale);

  let jollyModalProduct = document.querySelector('jolly-modal-product');
  const jollyModalInner = document.getElementById('jolly-modal-product');
  jollyModalInner.innerHTML = html;

  const addToCartBtn = jollyModalInner.querySelector('[js-add-to-cart-btn]');

  if (isUpsale == true) {
    addToCartBtn.classList.add('jc-upsales-button');
  }

  jollyModalProduct.classList.remove('jc-translate-y-full')
  jollyModalProduct.classList.add('jc-translate-y-0')
}


if (!customElements.get("jolly-product-card")) {
  customElements.define(
    "jolly-product-card",
    class JollyProductCard extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          addMobileCard: this.querySelectorAll('.jc-mobile-cart-item-add'),
          addBtn: this.querySelectorAll('[js-add-to-cart-btn]')
        }

        this.addEventListener('mouseleave', ()=>{
          this.querySelector('.jc-product-img--hover').removeAttribute('style');
        }); 

        this.elements.addMobileCard.forEach((element) => {
          element.addEventListener('click', (event) => {
            event.preventDefault();
            let productId = this.getAttribute('jolly-card-id');
            let section = this.querySelector('.jolly-card-section').dataset.section;
            let isUpsale = false;

            if (element.classList.contains('jc-mobile-upsale-item')) {
              isUpsale = true;
            }

            document.getElementById('jc-modal-shadow').classList.remove('jc-hidden');
            setModalContent(section, productId, isUpsale);
          });
        })
      }
    });
}

async function renderCartItems(eventUpdate, section, line) {
  const html = await getSectionHTML(section);

  const domparser = new DOMParser();
  const cartDom = domparser.parseFromString(html, "text/html");
  const cartDrawer = document.querySelector('#cart-drawer');
  const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
  const cartDrawerItemsSize = cartDrawer.querySelector('#cart_items_size');
  const cartDrawerFooter = cartDrawer.querySelector('cart-drawer-footer');
  const updatedItemPrice = cartDrawer.querySelector(`#CartDrawer-Item-${line} .price`);


  if (eventUpdate == true) {
    updatedItemPrice.innerHTML = cartDom.querySelector(`#CartDrawer-Item-${line} .price`)?.innerHTML;
  } else {
    cartDrawerItems.innerHTML = cartDom.querySelector('cart-drawer-items').innerHTML;
  }
  cartDrawerItemsSize.innerHTML = cartDom.querySelector('#cart_items_size')?.innerHTML;
  cartDrawerFooter.innerHTML = cartDom.querySelector('cart-drawer-footer').innerHTML;

  document.dispatchEvent(new CustomEvent("jc-cart:reload"));
  window.dispatchEvent(checkRecommendedProductsEvt);

  checkGift();
}


async function renderProgressBar() {
  const section = document.getElementById('cart-drawer').dataset.sectionId;
  const html = await getSectionHTML(section);
  const domparser = new DOMParser();
  const cartDom = domparser.parseFromString(html, "text/html");
  const progressBar = document.querySelector('cart-drawer-progressbar');

  if (!progressBar) return;

  const progressBarTop = cartDom.querySelector('.jc-progress-bar--top');
  const progressReward = cartDom.querySelector('.jc-price-reward').dataset.reward + '%';
  const progressText = cartDom.querySelector('.jc-progress-bar__text');

  progressBar.querySelector('.jc-progress-bar__text').innerHTML = progressText.innerHTML;
  progressBar.querySelector('.jc-progress-bar--top').innerHTML = progressBarTop.innerHTML;
  progressBar.querySelector('.jc-price-reward').style.setProperty('width', progressReward);
}

async function renderIconBubble() {
  const section = document.getElementById('cart-icon-bubble').dataset.sectionId;
  const html = await getSectionHTML(section);

  const domparser = new DOMParser();
  const cartDom = domparser.parseFromString(html, "text/html");
  const iconBubble = document.querySelector('#cart-icon-bubble');
  iconBubble.innerHTML = cartDom.querySelector('#cart-icon-bubble').innerHTML;
}

async function updateProductFromCart(eventUpdate, line, quantity) {
  const url = window.Shopify.routes.root + 'cart/change.js';
  const data = {
    line,
    quantity,
  };

  const section = 'cart-drawer';

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const cart = await response.json();

    renderCartItems(eventUpdate, section, line);
    renderProgressBar();
    renderIconBubble();

  } catch (error) {
    console.error("Error removing product from cart:", error);
  } finally {

    document.querySelectorAll('quantity-input').forEach((quantityInput) => {
      quantityInput.classList.remove('jc-pointer-events-none')
    });

    document.querySelectorAll('.loading-overlay').forEach((loader) => {
      loader.classList.add('jc-hidden');
    })
  }
}

/// remove from cart
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      let lineItem = this.dataset.index;
      let quantity = 0;
      let eventUpdate = false;

      this.closest('.js-cart-item').querySelector('.loading-overlay').classList.remove('jc-hidden');

      updateProductFromCart(eventUpdate, lineItem, quantity)
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);


/// add to cart
class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      btn: this.querySelector('[js-add-to-cart-btn]')
    }

    this.elements.btn.addEventListener('click', (el) => {
      el.preventDefault();

      let variantId = this.elements.btn.dataset.id;

      let data = {
        items: [{ id: variantId, quantity: 1 }],
        sections: ["cart-drawer", "cart-icon-bubble"]
      };

      const cart_drawer = document.querySelector('cart-drawer').dataset.sectionId;

      this.elements.btn.querySelector('.btn-label').style.opacity = 0
      this.elements.btn.querySelector('.btn-load').style.opacity = 1

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
      })
        .then(async response => {
          let json = await response.json();


          document.dispatchEvent(new CustomEvent("jc-add-to-cart:click"));

          checkGift();

          renderIconBubble();

          fetch(window.Shopify.routes.root + '?sections=' + cart_drawer)
            .then(response2 => response2.json())
            .then(data => {
              let html = data[cart_drawer]
              const domparser = new DOMParser();
              const cartDom = domparser.parseFromString(html, "text/html");

              document.querySelector('.drawer__inner').innerHTML = cartDom.querySelector('.drawer__inner').innerHTML;
              document.querySelector('cart-drawer').classList.remove('is-empty');
              document.querySelector('cart-drawer').classList.add('active');
              document.dispatchEvent(new CustomEvent("jc-cart:reload"));

              document.querySelectorAll('quantity-input').forEach((quantityInput) => {
                quantityInput.classList.remove('jc-pointer-events-none')
              });

              if (this.elements.btn.classList.contains('jc-upsales-button')) {
                let upsaleProducts = document.querySelectorAll('[id*="CartDrawer-Item"]');

                upsaleProducts.forEach(product => {
                  let productId = product.getAttribute('jolly-cart-item');

                  document.querySelectorAll('[jolly-upsale-slide]').forEach((item) => {
                    item.classList.remove('!jc-hidden');
                  })

                  document.querySelectorAll('[jolly-upsale-slide="' + productId + '"]').forEach((item) => {
                    item.classList.add('!jc-hidden');
                  })
                });
              }
            })

          const label = this.elements.btn.querySelector('.btn-label').innerHTML
         // this.elements.btn.querySelector('.btn-label').innerHTML = translations.products.productAdded
          this.elements.btn.classList.add('with-success')

          if (json.items.length == 0) {
            document.querySelector('cart-drawer').classList.add('is-empty');
          }

          document.querySelector('cart-drawer').classList.remove('is-empty');
          document.querySelector('cart-drawer').classList.add('active');

          if (this.elements.btn.classList.contains('jc-upsales-button')) {
            let upsaleProducts = document.querySelectorAll('[id*="CartDrawer-Item"]');

            upsaleProducts.forEach(product => {
              let productId = product.getAttribute('jolly-cart-item');

              document.querySelectorAll('[jolly-upsale-slide]').forEach((item) => {
                item.classList.remove('!jc-hidden');
              })

              document.querySelectorAll('[jolly-upsale-slide="' + productId + '"]').forEach((item) => {
                item.classList.add('!jc-hidden');
              })
            });
          }

          this.elements.btn.querySelector('.btn-label').style.opacity = 1
          this.elements.btn.querySelector('.btn-load').style.opacity = 0

          setTimeout(() => {
            this.elements.btn.querySelector('.btn-label').innerHTML = label
            this.elements.btn.classList.remove('with-success')
          }, 2000)
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }
}

customElements.define("add-to-cart", AddToCart);


class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.querySelector('.drawer__close').addEventListener('click', (el) => {
      this.close();
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector("cart-drawer") ||
          this.querySelector(".drawer__close");
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

// cart drawer quantity inputs
let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.productId = this.dataset.productId;
    this.removeBtn = this.querySelector("cart-remove-button");

    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
      let quantity = this.input.value;
      let lineItem = this.input.dataset.index;

      let eventUpdate = true;

      this.closest('.js-cart-item').querySelector('.loading-overlay').classList.remove('jc-hidden');

      updateProductFromCart(eventUpdate, lineItem, quantity)

      this.classList.add('jc-pointer-events-none')
    }
    else {
      return;
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".jc-quantity-btn[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
      buttonMinus.classList.toggle("!jc-hidden", value <= 1);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".jc-quantity-btn[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }

    if (value <= 1) {
      this.removeBtn.classList.remove('!jc-hidden')
    } else {
      this.removeBtn.classList.add('!jc-hidden')
    }

  }
}

customElements.define("quantity-input", QuantityInput);


class VariantChange extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      variants: this.querySelectorAll('[js-variants-values]'),
      variantsJSON: this.querySelector('[data-product-variants-json]'),
      sectionId: 'ajax-jolly-product-info',
    };
  }

  async updateProductInfo(productHandle, currentVariantId, sectionId) {

    if (window.innerWidth <= 992) {
      sectionId = 'ajax-jolly-atc-product';
    }

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${productHandle}?variant=${currentVariantId}&section_id=${sectionId}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const data = await response.text();
      const parser = new DOMParser();
      const parsedData = parser.parseFromString(data, 'text/html');

      const newVariantsHtml = parsedData.querySelector('.jc-product-card-controls')?.innerHTML;
      const newImagesSrc = parsedData.querySelector('[js-product-images] .jc-product-img')?.src;
      const newImagesSrcset = parsedData.querySelector('[js-product-images] .jc-product-img')?.dataset.srcset;

 
      if (newImagesSrc) {
        this.closest('jolly-product-card')
          .querySelector('.jc-product-img')
          .setAttribute('src', newImagesSrc);
        this.closest('jolly-product-card')
          .querySelector('.jc-product-img')
          .setAttribute('srcset', newImagesSrcset);
      }

      console.log('newVariantsHtml', newVariantsHtml);

      this.closest('.jc-product-card-controls').innerHTML = newVariantsHtml;
    } catch (error) {
      console.error(`An error occurred: ${error}`);
    }
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.elements.variants = this.querySelectorAll('[js-variants-values]');
    this.elements.variantsJSON = this.querySelector('[data-product-variants-json]');

    this.elements.variants.forEach((element) => {
      element.addEventListener('click', async () => {
        const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);
        const checkedInputs = this.querySelectorAll('[js-variants-values]:checked');
        let checkedOption = [];

        checkedInputs.forEach((input) => {
          checkedOption.push(input.value);
        });

        const matchingItems = parsedVariantsJSON.filter(
          (item) =>
            checkedOption.includes(item.option1) && checkedOption.includes(item.option2)
        );

        const productHandle = this.dataset.productHandle;
        let currentVariantId = '';

        currentVariantId = matchingItems[0].id;
        const sectionId = this.elements.sectionId;

        await this.updateProductInfo(productHandle, currentVariantId, sectionId);
      });

      element.addEventListener('mouseover', () => {
        if (!element.classList.contains('color')) {
          return;
        }

        let checkboxVal = element.value;

        const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);

        function findVariantIdByOption(parsedVariantsJSON, option) {
          for (let i = 0; i < parsedVariantsJSON.length; i++) {
            if (
              parsedVariantsJSON[i].options.includes(option) &&
              parsedVariantsJSON[i].featured_image &&
              parsedVariantsJSON[i].featured_image.src
            ) {
              return parsedVariantsJSON[i].featured_image.src;
            }
          }
          return null;
        }

        const variantImage = findVariantIdByOption(parsedVariantsJSON, checkboxVal);
 
        // if (variantImage !== null) {
        //   element.closest('jolly-product-card')
        //     .querySelector('.jc-product-img')
        //     ?.removeAttribute('srcset');
        //   element.closest('jolly-product-card')
        //     .querySelector('.jc-product-img')
        //     ?.setAttribute('src', variantImage);
        //   element
        //     .closest('jolly-product-card')
        //     .querySelector('.jc-product-img--hover').style.opacity = 0;
        // }
      });
    });
  }
} 

customElements.define('variant-picker', VariantChange);



function checkGift() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const cartItems = data.items;
      const totalPrice = data.total_price;

      const isGift = cartItems.filter(item => {
        return item.properties && item.properties._isGift === 'true';
      });

      const giftPrice = Number(document.querySelector('#jc-cart-gift')?.dataset.giftTotal);
      const giftProduct = document.querySelector('#jc-cart-gift')?.dataset.giftId;

      if (totalPrice > giftPrice && isGift.length == 0) {
        let data = {
          items: [{
            id: giftProduct,
            quantity: 1,
            properties: {
              '_isGift': 'true'
            }
          }],
          sections: ["cart-drawer", "cart-icon-bubble"]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data)
        })
          .then(async response => {
            let json = await response.json();

            renderIconBubble();
            const cart_drawer = document.querySelector('cart-drawer').dataset.sectionId;

            fetch(window.Shopify.routes.root + '?sections=' + cart_drawer)
              .then(response2 => response2.json())
              .then(data => {
                let html = data[cart_drawer]
                const domparser = new DOMParser();
                const cartDom = domparser.parseFromString(html, "text/html");

                document.querySelector('.drawer__inner').innerHTML = cartDom.querySelector('.drawer__inner').innerHTML;
                document.dispatchEvent(new CustomEvent("jc-cart:reload"));
              })
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else if (totalPrice < giftPrice && isGift.length > 0) {
        const giftToremove = document.querySelector('[data-variant-id="' + giftProduct + '"] cart-remove-button')

        if (giftToremove) {
          giftToremove.click();
        }
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

checkGift();

document.addEventListener('jc-gift:check', function () {
  checkGift();
})